module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/home-6c90455870e4e45c83b7f97b654fa104.png";